import React from "react";
import { ConfigProvider, Form, type FormProps, type ThemeConfig } from "antd";

const orderSearchControlHeight = 22;

const orderSearchFormTheme: ThemeConfig = {
    hashed: true,
    components: {
        Button: {
            controlHeightSM: orderSearchControlHeight,
        },
        Form: {
            labelColonMarginInlineEnd: 0,
            labelColonMarginInlineStart: 0,
        },
        Input: {
            controlHeightSM: orderSearchControlHeight,
        },
        Select: {
            controlHeightSM: orderSearchControlHeight,
        },
    },
};

const OrderSearchForm: React.FC<FormProps> = (props) => {
    return (
        <ConfigProvider theme={orderSearchFormTheme}>
            <Form {...props} />
        </ConfigProvider>
    );
};

export default OrderSearchForm;
